import axios from 'axios';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { loginStory } from './stories/login.js';
import { toast } from 'react-toastify';
import validator from 'services/validator.js'

const {
  changePasswordSaga,
  addValidateError,
  cleanErrors,
  addErrorsSaga
} = actions;

const {
  CHANGE_PASSWORD_SAGA,
  API_UPDATE_USER
} = constants;

const apiChangePassword = ({ id, password }) => (
  axios.put(`${API_UPDATE_USER}${id}`, {
    user: {
      password
    }
  })
)

function* invalidPasswordError() {
  toast.error('Invalid password')
}

function* notififyPasswordUpdate() {
  toast.success('Your password has been changed successfully')
}

function* isPasswordRight({ email, old_password }) {
  try {
    const response = yield call(loginStory, email, old_password) || {};
    return response.status == 200
  } catch (e) {
    return e.response.status != 401
  }
}

function* changePassword({ user }) {
    try {
      const errors = validator.validate(user, 'newPassword');
      if (errors) {
        yield put(addValidateError(CHANGE_PASSWORD_SAGA, errors));
        return;
      } else {
        yield put(cleanErrors(CHANGE_PASSWORD_SAGA))
      }

      const passwordVerified = yield call(isPasswordRight, user);

      if (!passwordVerified) {
        yield call(invalidPasswordError)
        return null;
      }

      const response = yield call(apiChangePassword, user);

      yield call(notififyPasswordUpdate);

    } catch (e) {
      console.log(e);
      yield put(addErrorsSaga(CHANGE_PASSWORD_SAGA, e.response))
    }
}

function* __changePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD_SAGA, changePassword);
}

export {
  __changePasswordSaga
};



/** WEBPACK FOOTER **
 ** ./src/sagas/changePassword.js
 **/